import Modal from "../../components/portal/Modal";
import React, {useCallback} from "react";
import {AutoCheckInConfig} from "./types";
import {noop} from "lodash";
import {IconButton} from "../../features/management-v2/import/inputs";
import DeleteIcon from "@mui/icons-material/Delete";
import {useDeleteCheckInConfig} from "./useDeleteCheckInConfig";
import LoadingSpinner from "../../components/ui/LoadingSpinner";
import {ErrorMessage} from "./index";

type DeleteProfileModalProps = {
    show?: boolean;
    setShow?: (show: boolean) => void;
    profile: AutoCheckInConfig;
    refetch: () => void;
}

export function DeleteProfileModal({
        show = false,
        setShow = noop,
        profile,
        refetch = noop,
    }: DeleteProfileModalProps){

    const {submit, submitting, error} = useDeleteCheckInConfig(profile.id, refetch);

    const handleDelete = useCallback(async () => {
        const res = await submit()
        if(res){
            setShow(false)
        }
    }, [submit])

    return (
        <Modal open={show} setOpen={setShow}>

            <div className="bg-white shadow-md p-4 flex flex-col gap-4 rounded-md">
                <p className={"font-semibold"}>Delete Profile</p>
                <p>Please click to confirm deletion of profile ({profile.name})</p>

                <div className="flex flex-col gap-2">
                    <IconButton color="red"
                                text="Delete Profile"
                                icon={submitting ? <LoadingSpinner width={20} height={20} color={"#ffffff"}/> : <DeleteIcon />}
                                disabled={submitting}
                                onClick={handleDelete}
                    />
                    <ErrorMessage text={error}/>
                </div>
            </div>
        </Modal>

)

}